/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { Card, Alert, Row, Col, Form, Table } from 'react-bootstrap';
import { LoadSkuRequest } from '../../../features/Sku/SkuSlice';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import Pagination from '../../../components/shared/Pagination';
import SkuLine from '../../../components/shared/SkuLine';
import SkuDrawer from '../../../components/shared/SkuLine/Drawer';
import { useCurrentCompanyID, useCurrentCompanyFullName } from '../../../hooks/useCurrentCompany';

function SkuBreakDown() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showDesc, setShowDesc] = useState(false);
  const [currentSku, setCurrentSku] = useState({});

  const companyId = useCurrentCompanyID();
  const companyFullName = useCurrentCompanyFullName();

  useEffect(() => {
    if (showDesc) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [showDesc]);

  const { currentVendor } = useSelector((state) => state.vendor);
  const loading = useSelector((state) => state.loader.open);
  const { list, count } = useSelector((state) => state.sku);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (
      Object.keys(currentVendor).length > 0 &&
      currentVendor.VendorType.toLowerCase() !== 'supplier'
    ) {
      toast.error('Sku Breakdown are only available for Supplier');
      navigate('/');
    }
  }, [currentVendor]);

  async function fetchSkuList() {
    if (currentVendor && Object.keys(currentVendor).length > 0) {
      await dispatch(loaderActions.show());
      await dispatch(
        LoadSkuRequest({
          type: 'list',
          filter: `Vendor_No eq '${currentVendor.vendNo}'`,
          companyId,
          currentPage,
          pageSize
        })
      );
      await dispatch(loaderActions.hide());
    }
  }

  useEffect(() => {
    fetchSkuList();
  }, [currentVendor, pageSize, currentPage]);

  const filteredSku = list.filter(
    (sku) =>
      sku.No.toLowerCase().includes(search.trim().toLowerCase()) ||
      sku.Description.toLowerCase().includes(search.trim().toLowerCase())
  );

  const tableRows = filteredSku.map((sku, i) => (
    <SkuLine
      sku={sku}
      key={i}
      showDetails={(sku) => {
        setCurrentSku(sku);
        setShowDesc(true);
      }}
    />
  ));

  const ErrorCard = (
    <>
      <Alert variant="warning">
        {currentVendor !== undefined ? (
          `No Sku Available for ${currentVendor.vendName}`
        ) : (
          <> No Sku Available</>
        )}
      </Alert>
    </>
  );

  const SearchErrorCard = (
    <>
      <Alert variant="warning">
        <> No Sku matching current search</>
      </Alert>
    </>
  );

  return (
    <>
      <Row>
        <Col md={{ span: 4, offset: 8 }} sm={{ span: 6, offset: 6 }} xs={{ span: 12 }}>
          <div className="d-flex">
            <Form.Control
              size="sm"
              type="text"
              className="mr-2"
              placeholder="Search "
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col xl={12} md={12}>
          {filteredSku.length > 0 ? (
            <Card className="shadow-sm ">
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Sku #</th>
                      <th>Description</th>
                      <th>Type</th>
                      <th>Unit Cost</th>
                      <th>Last Date Modified</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>{tableRows}</tbody>
                </Table>
              </Card.Body>
            </Card>
          ) : list.length > 0 ? (
            SearchErrorCard
          ) : loading ? (
            <></>
          ) : (
            ErrorCard
          )}
          {count > pageSize ? (
            search.trim().length === 0 ? (
              <Card className="shadow-sm pt-2">
                <Card.Body>
                  <Row>
                    <Col>
                      <p>Total Sku: {count}</p>
                      <p>
                        Currently Viewing : {(currentPage - 1) * pageSize + 1} to{' '}
                        {currentPage * pageSize > count ? count : currentPage * pageSize}
                      </p>
                    </Col>
                    <Col className="text-center">
                      <Form.Group className="mt-2">
                        <Form.Control
                          as="select"
                          onChange={(e) => {
                            setCurrentPage(1);
                            setPageSize(e.target.value);
                          }}
                          value={pageSize}
                        >
                          <option value="10">Sku per page: 10</option>
                          <option value="20">Sku per page: 20</option>
                          <option value="25">Sku per page: 25</option>
                          <option value="50">Sku per page: 50</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="text-right mt-2">
                      <Pagination
                        className="pagination-bar"
                        currentPage={currentPage}
                        totalCount={count}
                        pageSize={pageSize}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <SkuDrawer sku={currentSku} showDesc={showDesc} setShowDesc={setShowDesc} />
    </>
  );
}

export default SkuBreakDown;
